/* eslint-disable react/display-name */
import React from "react";

import { EditOutlined } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import parse from "html-react-parser";
import { connect } from "react-redux";

const PostPreviewCard = ({
  user,
  template,
  company,
  postContent,
  showEditBtn,
  hfull,
  postContentLoading,
  onEditClick,
  cardStyles = {},
}) => {
  const profileName =
    user?.socials?.linkedin?.page?.page_name ||
    user?.personal_information?.first_name;
  const profileImg = user?.socials?.linkedin?.page?.profile_picture;

  return (
    <Box
      sx={{
        borderRadius: "5px",
        m: 2,
      }}
    >
      <Card
        sx={{
          p: "1.5rem",
          height: hfull ? "auto" : "60vh",
          bgcolor: "#FBFBFB",
          borderRadius: "8px",
          boxShadow: "none",
          border: "1px solid #d1d1d1",
          overflow: "auto",
          ...cardStyles,
        }}
      >
        <Box display="flex" justifyContent="space-between" gap={1} pb={2}>
          <Box display="flex" gap={2} alignItems="center">
            <Avatar src={profileImg} />
            <Typography fontWeight={500} fontSize=".8rem">
              {profileName || "Username"}
            </Typography>
          </Box>
          {showEditBtn && (
            <IconButton
              size="small"
              sx={{
                width: "30px",
                height: "30px",
                borderRadius: "30px",
                boxShadow: 2,
                bgcolor: "white",
              }}
              onClick={onEditClick}
            >
              <EditOutlined
                sx={{ width: "18px", height: "18px", color: "#A8A8A8" }}
              />
            </IconButton>
          )}
        </Box>
        {postContentLoading && (
          <Box mt={8} className="center" mb={2}>
            <CircularProgress />
          </Box>
        )}
        {!postContentLoading && postContent && (
          <Typography className="post_content_container" mb={1}>
            {parse(postContent)}
          </Typography>
        )}

        {template &&
          (typeof template.renderTemplate === "function" ? (
            // Case 1: Template has renderTemplate method
            template.renderTemplate({
              logo: company?.company_informations?.logo,
              ...company?.color_theme,
              width: "100%",
              height: "100%",
            })
          ) : (
            <img
              src={template.url || template} // Support both `{ url: ... }` and raw string
              alt="Template Preview"
              style={{ width: "100%", height: "15rem", objectFit: "contain" }}
            />
          ))}
      </Card>
    </Box>
  );
};

// Map state to props as before
const mapStateToProps = (state) => ({
  user: state.auth.user,
  company: state.company.company,
});

export default connect(mapStateToProps)(PostPreviewCard);
